import {UserContextService} from '../app-context/user-context/user-context.service';
import {UserContext} from '../app-context/user-context/user-context';
import {Observable} from 'rxjs';
import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot} from '@angular/router';
import {map} from 'rxjs/operators';
import packageJson from 'package.json';

@Injectable({
              providedIn: 'root'
            })
export class AuthGuard implements CanActivate {

  static readonly APP_VERSION = `app.version`;

  private static clearLocalStorageIfOtherVersion(): void {
    if (packageJson.version === localStorage.getItem(AuthGuard.APP_VERSION)) {
      return;
    }
    localStorage.clear();
    localStorage.setItem(AuthGuard.APP_VERSION, packageJson.version);
  }

  constructor(private userContextService: UserContextService) {
    AuthGuard.clearLocalStorageIfOtherVersion();
  }

  public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Observable<boolean> {
    return this.userContextService.getUserContext() ? true
                                                    : this.userContextService.initUserContextFromLoggedUser()
                                                          .pipe(
                                                            map((userContext: UserContext) => userContext && true)
                                                          );
  }

}
